import { render } from "./ChristmasQuizCompleteCorrectPage.vue?vue&type=template&id=a40bdfd6&scoped=true"
import script from "./ChristmasQuizCompleteCorrectPage.vue?vue&type=script&lang=js"
export * from "./ChristmasQuizCompleteCorrectPage.vue?vue&type=script&lang=js"

import "./ChristmasQuizCompleteCorrectPage.vue?vue&type=style&index=0&id=a40bdfd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40bdfd6"]])

export default __exports__